import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form, Input, Modal } from 'antd';

import { addBlueprintVersion, selectors } from 'state';

type Props = {
  blueprintId: number;
  visible: boolean;
  hide: () => void;
};

/** Bump the family to a new DRAFT version (clones all variants of the latest). */
const AddVersionModal: React.FC<Props> = ({ blueprintId, visible, hide }) => {
  const dispatch = useDispatch();
  const waiting = useSelector(selectors.blueprintsWaiting);
  const [form] = Form.useForm();

  return (
    <Modal
      title="New version"
      open={visible}
      onCancel={hide}
      footer={null}
      width={480}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ changelog: '' }}
        onFinish={() => {
          const data = form.getFieldsValue() as { changelog?: string };
          dispatch(
            addBlueprintVersion({
              id: blueprintId,
              changelog: data.changelog || undefined,
            }),
          );
          hide();
        }}
      >
        <Form.Item label="Changelog" name="changelog">
          <Input.TextArea
            placeholder="What changed in this version?"
            rows={3}
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={hide} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={waiting}>
            Add version
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddVersionModal;
